import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-edit-session-timeout-dialog',
    templateUrl: './edit-session-timeout-dialog.component.html',
    styleUrls: ['./edit-session-timeout-dialog.component.css'],
    standalone: false,
})
export class EditSessionTimeoutDialog {
    timeoutSet = [0, 10, 20, 30, 40, 50, 60];
    selectedTimeout: number;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            sessionTimeout: number;
        },
        private dialogRef: MatDialogRef<EditSessionTimeoutDialog>
    ) {}

    ngOnInit() {
        this.selectedTimeout = this.data.sessionTimeout ?? 0;
    }

    cancelClick() {
        this.dialogRef.close();
    }

    async saveChanges() {
        this.dialogRef.close(this.selectedTimeout);
    }
}
